<div class="error-state-container">
  <div class="error-state-content">
    <div class="error-state-inner">
      <!-- Icon -->
      <div class="icon-wrapper" [ngClass]="'icon-wrapper-' + type">
        <g99-icon-btn [icon]="icon" [height]="32" [width]="32" />
      </div>

      <!-- Content -->
      <div class="content">
        <h3 class="title">{{ title }}</h3>
        <p *ngIf="subtext" class="description">{{ subtext }}</p>
      </div>

      <!-- Action Button -->
      <div class="actions">
        <g99-button
          *ngIf="showButton"
          width="120"
          variant="medium"
          color="secondary"
          [svgIcon]="buttonIcon"
          (buttonClick)="onButtonClick()"
        >
          {{ buttonLabel }}
        </g99-button>
      </div>

      <div *ngIf="hasAdditionalContent" class="additional-content">
        <ng-content />
      </div> </div></div
></div>
